<template>
  <div style="position: relative;">
    <button class="button" @click="toggleDatePicker">{{ value ? $moment(value).format('DD/MM/YYYY') : 'Salary Responded At' }}</button>
      <input
      v-if="showDatePicker"
      type="date"
      :value="formattedValue"
      ref="dateInput"
      @change="handleDateChange"
      @blur="hideDatePicker"
      onfocus="showPicker()"
      />
  </div>
</template>

<script>
export default {
  name: 'ApplicantSalaryRespondedAt',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    applicantId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showDatePicker: false
    }
  },
  computed: {
    formattedValue () {
      return this.value || this.getTodayDate()
    }
  },
  methods: {
    toggleDatePicker () {
      this.showDatePicker = !this.showDatePicker
      this.$nextTick(() => {
        if (this.showDatePicker) {
          this.$refs.dateInput.focus()
        }
      })
    },
    showPicker () {
      this.showDatePicker = true
    },
    hideDatePicker () {
      this.showDatePicker = false
    },
    getTodayDate () {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    async handleDateChange (event) {
      const selectedDate = event.target.value
      this.$emit('input', selectedDate)
      try {
        await this.$network_utils.updateApplicant({
          applicant_id: this.applicantId,
          salary_responded_at: selectedDate
        })
        this.$utils.emit('show_toast', { text: 'Success' })
      } catch (e) {
        this.$utils.emit('show_toast', { text: 'Failed' })
      } finally {
        this.showDatePicker = false
      }
    }
  }
}
</script>

<style scoped>
.button {
  cursor: pointer;
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
}

.button:hover {
  background-color: #0056b3;
}

input[type="date"] {
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 0;
  height: 0;
}
</style>
